import PageHeader from '../PageHeader'
import Image from '../../images/header-contact.png'

const HeaderContact = () => {
  return (
    <PageHeader pageName="contact" imageUrl={Image}>
        <h2 className="image-text">Reach Out to Be-Loved Ceremonies</h2>
    </PageHeader>
  )
}

export default HeaderContact